import React from 'react';
import { motion } from 'framer-motion';

const WhyChooseIESGear = () => {
  const features = [
    {
      title: 'Premium Boxing Gear',
      desc: 'High-quality boxing gloves and equipment designed for durability and elite performance.',
    },
    {
      title: 'Expert Craftsmanship',
      desc: 'Handcrafted in Sialkot — the global hub of sports manufacturing excellence.',
    },
    {
      title: 'Wide Product Range',
      desc: 'From activewear to boxing gear, we cover every performance need.',
    },
    {
      title: 'Global Reputation',
      desc: 'Trusted by athletes and professionals across 20+ countries worldwide.',
    },
    {
      title: 'Customer Satisfaction',
      desc: 'Driven by quality, trusted by 3000+ satisfied clients globally.',
    },
  ];

  return (
    <section className="py-24 px-6 bg-gradient-to-b from-white to-gray-100">
      <div className="max-w-7xl mx-auto">

        {/* Heading */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-16"
        >
          <h2 className="text-3xl md:text-4xl font-orbitron font-semibold text-black leading-tight">
            Why Choose IES <span className="text-red-600">Gear</span>
          </h2>
          <p className="mt-4 text-gray-600 max-w-2xl">
            Designed for champions. Built with precision. Trusted worldwide.
          </p>
        </motion.div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((item, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1, duration: 0.5 }}
              whileHover={{ y: -8 }}
              className="bg-white p-6 rounded-2xl shadow-sm hover:shadow-xl transition-all border border-gray-100 group"
            >
              <h3 className="text-lg font-semibold text-black mb-2 group-hover:text-red-600 transition">
                {item.title}
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                {item.desc}
              </p>

              {/* Accent Line */}
              <div className="mt-4 h-[2px] w-10 bg-red-600 transition-all duration-300 group-hover:w-16"></div>
            </motion.div>
          ))}
        </div>

        {/* Bottom Statement */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.3, duration: 0.6 }}
          className="mt-16 text-center"
        >
          <p className="text-lg text-black">
            <span className="font-semibold">Gear up with IES </span>
            <span className="text-red-600 font-orbitron font-semibold">Gear</span>
            {' '}and elevate your performance.
          </p>
          <p className="text-gray-600 text-sm mt-2">
            Built for professionals. Trusted by athletes. Designed to win.
          </p>
        </motion.div>

      </div>
    </section>
  );
};

export default WhyChooseIESGear;